<template id="pagination">
  <nav v-if="this.totalPages >= 2" role="navigation" aria-label="paginering">
    <ul class="pagination">
      <li class="pagination__item pagination__item--previous">
        <a href="" v-if="!isInFirstPage" @click.prevent="onClickPreviousPage" class="pagination__link" tabindex="0"><span>Vorige</span><span class="screenreader-only">&nbsp;pagina</span></a>
      </li>

      <li v-for="page in pages" v-bind:key="page.name" class="pagination__item" :class="{ 'pagination__item pagination__item--active': isPageActive(page.name) }">
        <a href="" v-if="!page.isDisabled"
        class="pagination__link"
          @click.prevent="onClickPage(page.name)"
          :aria-label="`Ga naar pagina ${page.name}`"
        tabindex="0"
        >
          {{ page.name }}
        </a>
        <span v-if="page.isDisabled">{{ page.name }}</span>
      </li>

    <li class="pagination__item pagination__item--total">
      <span class="screenreader-only">Pagina</span>{{this.totalPages}}
    </li>
    
      <li class="pagination__item pagination__item--next">
        <a href="" v-if="!isInLastPage" @click.prevent="onClickNextPage" class="pagination__link" tabindex="0"><span>Volgende <span class="screenreader-only">&nbsp;pagina</span></span></a>
      </li>
    </ul>
  </nav>
</template>

<script>

  export default {
      name: "PaginationComponent",
      template: '#pagination',
      props: {
        maxVisibleas: {
          type: Number,
          required: false,
          default: 3
        },
        totalPages: {
          type: Number,
          required: true
        },
        total: {
          type: Number,
          required: true
        },
        perPage: {
          type: Number,
          required: true
        },
        currentPage: {
          type: Number,
          required: true
        },
      },

      computed: {

          startPage() {
          if (this.currentPage === 1) {
            return 1;
          }
          if (this.currentPage === this.totalPages) {
            return this.totalPages - this.maxVisibleas + 1;
          }
          return this.currentPage - 1;
        },
        endPage() {

          return Math.min(this.startPage + this.maxVisibleas - 1, this.totalPages);

        },
        pages() {
          const range = [];

          for (let i = this.startPage <= 0? 1: this.startPage; i <= this.endPage; i+= 1 ) {
            range.push({
              name: i,
              isDisabled: i === this.currentPage
            });
          }

          return range;
        },
        isInFirstPage() {
          return this.currentPage === 1;
        },
        isInLastPage() {
          return this.currentPage === this.totalPages;
        },
      },

      methods: {
        scrollToTop() {
          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
        },
        countPages: function () {
        },
        onClickFirstPage() {
          this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
          this.scrollToTop();
          if (this.$matomo) {
            this.$matomo.trackEvent("Initiatief-scholen", "pagina", "vorige");
          }
          this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
          this.scrollToTop();
          this.$emit('pagechanged', page);
        },
        onClickNextPage() {
          this.scrollToTop();
          if (this.$matomo) {
            this.$matomo.trackEvent("Initiatief-scholen", "pagina", "volgende");
          }
          this.$emit('pagechanged', this.currentPage + 1);
        },
        onClickLastPage() {
          this.$emit('pagechanged', this.totalPages);
        },
        isPageActive(page) {
          return this.currentPage === page;
        },
      },

    created: function () {
      this.countPages();
    }
  };
</script>


